import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";

const NOTICES = {
  story_gone: "Cette story n'est plus disponible",
  post_gone: "Cette publication n'est plus disponible",
  live_gone: "Ce direct n'est plus disponible",
  schedule_gone: "Ce direct programmé n'existe plus",
  church_gone: "Cette église n'est plus disponible",
};

// `?notice=<key>` appended by the share pipeline (expired story → author's profile…):
// shows the message once, then removes the parameter from the URL.
export const ShareNotice = () => {
  const { search, pathname, hash } = useLocation();
  const navigate = useNavigate();
  const { t } = useApp();
  useEffect(() => {
    const sp = new URLSearchParams(search);
    const key = sp.get("notice");
    if (!key || !NOTICES[key]) return;
    toast.info(t(`share.${key}`, NOTICES[key]), { id: `share-notice-${key}`, duration: 6000 });
    sp.delete("notice");
    const q = sp.toString();
    navigate(`${pathname}${q ? `?${q}` : ""}${hash || ""}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  return null;
};

export default ShareNotice;
